import * as React from "react";
import {Box, Text} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";
import {Link, useLocation} from "react-router-dom";
import styled from "styled-components";

import {rootURL} from "shared/Utils/WhereAmI";
import {UNIVERSITY_MULTI_CHOICE_CHAT} from "shared/constants";

import useUniversityColor from "../../../UniversityProvider/hooks/useUniversityColor";
import {useUniversity} from "../../../UniversityProvider/UniversityProvider";
import {InboxProfileImage} from "../../../../../components/InboxProfileImage/InboxProfileImage";
import {useUser} from "../../../User/useUser";
import {useUniversityMessageCount} from "./hooks/useUniversityMessageCount";
import {IntlNamespaces} from "../../../../../translations/types";
import {INTL_LOGO} from "../../../../../translations/common";
import {isFunction} from "../../../../../util/isFunction";
import {INTL_GREETING} from "../../../../../translations/universityChat";

const StyledLink = styled(Link)`
    &:hover {
        text-decoration: none;
        background-color: #f7f8f9 !important;
    }
    text-decoration: none !important;
`;

const StyledBox = styled(Box)`
    &:hover {
        background-color: #f7f8f9 !important;
    }
`;

const MessageIndicator: React.FC = () => {
    const messageCount = useUniversityMessageCount();
    const universityColor = useUniversityColor();

    if (messageCount === 0) {
        return null;
    }

    return (
        <Box
            minW="20px"
            minH="20px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="medium"
            bgColor={universityColor}
        >
            <Text size="small" color="white">
                {`${messageCount}`}
            </Text>
        </Box>
    );
};

export const UniversityInboxItem: React.FC = () => {
    const university = useUniversity();
    const {t} = useTranslation([IntlNamespaces.COMMON, IntlNamespaces.UNIVERSITY_CHAT]);
    const user = useUser();
    const routerLocation = useLocation();
    const baseUrl = rootURL(routerLocation.pathname);

    const INTL_INTRO_MSG_DEFAULT_VALUE = isFunction(INTL_GREETING.defaultValue)
        ? INTL_GREETING.defaultValue(user?.firstName)
        : INTL_GREETING.defaultValue;

    return (
        <StyledLink to={`${baseUrl}/inbox/${UNIVERSITY_MULTI_CHOICE_CHAT}`}>
            <StyledBox
                padding="small"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
            >
                <Box display="flex" alignItems="center">
                    <Box minW="40px" minH="40px">
                        <InboxProfileImage
                            src={university.squareLogo}
                            alt={`${university.name} ${t(INTL_LOGO.key, INTL_LOGO.defaultValue)}`}
                        />
                    </Box>
                    <Box display="flex" flexDirection="column" paddingLeft="small">
                        <Box paddingBottom="small">
                            <Text size="medium">{university.name}</Text>
                        </Box>
                        <Box w="100%">
                            <Text size="small" color="#757474" truncate>
                                {t(
                                    `${IntlNamespaces.UNIVERSITY_CHAT}:${INTL_GREETING.key}`,
                                    INTL_INTRO_MSG_DEFAULT_VALUE,
                                    {name: user?.firstName},
                                )}
                            </Text>
                        </Box>
                    </Box>
                </Box>
                <MessageIndicator />
            </StyledBox>
        </StyledLink>
    );
};
